module.exports = __webpack_public_path__ + "bd2df98692807dfd412473c52681d2b9.pdf";